import instance from '../utils/axios';

class DictionaryService {

    async getOptions(dictionaryName, pageIndex, pageSize, filter, keywords,colName) {
        return await instance.post(`/crm/common/CommonApi/GetZLSelectDict?dictionaryName=${dictionaryName}&filter=${filter}&pageIndex=${pageIndex - 1}&pageSize=${pageSize}&key=${keywords || ''}&colName=${colName || ''}`);
    }

    async getText(dictionaryName, values,colName) {
        values = values || '';
        let filter = 'uuid in (' + values.split(',').map(value => '\'' + value + '\'').join(',') + ')';
        return await instance.post(`/crm/common/CommonApi/GetZLSelectDict?dictionaryName=${dictionaryName}&filter=${filter || ''}&colName=${colName || ''}`);
    }
}

export default new DictionaryService();